<template>
  <section>
    <button
      class="modal-open-button"
      :class="{ 'active-dropdown': (dropdown && openToC) }"
      @click="toggleTableOfContents"
    >
      <i
        class="fas fa-list-alt prm"
      />
      <div class="">
        Contents
      </div>
      <i
        class="fas fa-caret-down pls"
      />
      <i
        class="fas fa-caret-up pls"
      />
    </button>
    <b-modal 
      :active.sync="openToC"
    >
      <div class="table-of-contents-button-container">
        <div class="columns">
          <TableOfContents
            :longform-document="longformDocument"
            @toggleTableOfContents="toggleTableOfContents"
          />
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import TableOfContents from '@/components/TableOfContents.vue';

export default {
  name: 'TableOfContentsButton',
  components: {
    TableOfContents,
  },
  props: {
    longformDocument: {
      type: Object,
      required: true,
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
  }, 
  data: function() {
    return {
      openToC: false,
    };
  },
  watch:{
    $route (){
      this.closeAll();
    },
  },
  methods: {
    toggleTableOfContents() {
      let vm = this;
      vm.openToC = !vm.openToC;
      // if (vm.dropdown && vm.openToC) {
      //   vm.$emit('toggleTableOfContents', vm.openToC);
      // }
    },
    closeAll() {
      let vm = this;
      vm.openToC = false;
    },
  },
};
</script>